(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-footer-location-open]');
    if (openButton) {
      var dialogId = openButton.getAttribute('aria-controls');
      var dialog = dialogId ? document.getElementById(dialogId) : document.querySelector('[data-footer-location-dialog]');
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    var closeButton = event.target.closest('[data-footer-location-close]');
    if (closeButton) closeButton.closest('dialog').close();
  });

  document.addEventListener('click', function (event) {
    var dialog = event.target.closest('[data-footer-location-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  });

  document.addEventListener('change', function (event) {
    var countrySelect = event.target.closest('[data-footer-location-country]');
    if (!countrySelect) return;

    var selectedOption = countrySelect.options[countrySelect.selectedIndex];
    var flag = countrySelect.closest('.footer-location-dialog__select-wrap').querySelector('[data-footer-location-flag]');
    if (flag && selectedOption && selectedOption.dataset.flag) flag.src = selectedOption.dataset.flag;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minroon-concept-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mr-home').forEach(function(home){
    var dialog=home.querySelector('[data-mr-dialog]');
    var open=home.querySelector('[data-mr-open]');
    var close=home.querySelector('[data-mr-close]');
    if(open){
      open.addEventListener('click',function(){
        var whatsappTarget=document.querySelector('a[href*="wa.me"],a[href*="api.whatsapp.com"],a[href*="whatsapp.com/send"],[aria-label*="WhatsApp" i],[title*="WhatsApp" i]');
        if(whatsappTarget&&whatsappTarget!==open){
          whatsappTarget.click();
          return;
        }
        window.open('https://api.whatsapp.com/send?text=Hello%20MINROON%2C%20I%20would%20like%20a%20personalized%20Five%20Elements%20crystal%20consultation.', '_blank', 'noopener');
      });
    }
    if(close&&dialog){close.addEventListener('click',function(){dialog.close();});}
    var carousel=home.querySelector('[data-product-carousel]');
    var previous=home.querySelector('[data-products-prev]');
    var next=home.querySelector('[data-products-next]');
    if(carousel&&previous&&next){
      var originalCards=Array.from(carousel.children);
      var originalCount=originalCards.length;
      var leading=document.createDocumentFragment();
      var trailing=document.createDocumentFragment();
      originalCards.forEach(function(card){leading.appendChild(card.cloneNode(true));});
      originalCards.forEach(function(card){trailing.appendChild(card.cloneNode(true));});
      carousel.insertBefore(leading,carousel.firstChild);
      carousel.appendChild(trailing);
      var getCardDistance=function(){
        var card=carousel.querySelector('.mr-product');
        var gap=parseFloat(getComputedStyle(carousel).columnGap)||0;
        return card?card.getBoundingClientRect().width+gap:carousel.clientWidth;
      };
      var getGroupWidth=function(){
        var rowCount=parseInt(getComputedStyle(carousel).getPropertyValue('--product-rows'),10)||1;
        return getCardDistance()*Math.ceil(originalCount/rowCount);
      };
      var moveProducts=function(direction){
        carousel.scrollBy({left:direction*getCardDistance(),behavior:'smooth'});
      };
      previous.addEventListener('click',function(){moveProducts(-1);});
      next.addEventListener('click',function(){moveProducts(1);});
      var normalizeCarouselPosition=function(){
        var groupWidth=getGroupWidth();
        var targetPosition=carousel.scrollLeft;
        if(targetPosition<=1){targetPosition+=groupWidth;}
        if(targetPosition>=groupWidth*2-1){targetPosition-=groupWidth;}
        if(Math.abs(targetPosition-carousel.scrollLeft)>1){
          carousel.style.scrollBehavior='auto';
          carousel.scrollLeft=targetPosition;
          carousel.offsetHeight;
          carousel.style.scrollBehavior='';
        }
      };
      if('onscrollend' in carousel){
        carousel.addEventListener('scrollend',normalizeCarouselPosition);
      }else{
        var loopTimeout;
        carousel.addEventListener('scroll',function(){
          clearTimeout(loopTimeout);
          loopTimeout=setTimeout(normalizeCarouselPosition,350);
        },{passive:true});
      }
      requestAnimationFrame(function(){carousel.scrollLeft=getGroupWidth();});
    }
    home.querySelectorAll('[data-zodiac]').forEach(function(button){
      button.addEventListener('click',function(){
        home.querySelectorAll('[data-zodiac]').forEach(function(item){item.classList.remove('is-active');});
        button.classList.add('is-active');
        home.querySelector('[data-zodiac-name]').textContent=button.dataset.name;
        home.querySelector('[data-zodiac-dates]').textContent=button.dataset.dates;
        home.querySelector('[data-zodiac-traits]').textContent=button.dataset.traits;
        home.querySelector('[data-zodiac-stones]').textContent=button.dataset.stones;
        var image=home.querySelector('[data-zodiac-image]');
        image.src=button.dataset.image;
        image.alt=button.dataset.name+' crystal bracelet';
        var link=home.querySelector('[data-zodiac-link]');
        link.href=button.dataset.url;
        link.firstChild.textContent='Explore '+button.dataset.name+' ';
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
